<template>
    <div class="field" :class="{'is-error': hasError}">
        <label class="field-label stack-s">Email Content</label>
        <div class="editor" :class="{'is-active': focused}">
            <div class="editor-menu">
                <div class="grid-fitted align-items-center">
                    <div class="grid-item">
                        <ul class="tab">
                            <li class="tab-item">
                                <a class="tab-link" :class="{'is-active': !isTextActive, 'has-error': hasError}" @click="switchToHTML">HTML</a>
                            </li>
                            <li class="tab-item">
                                <a class="tab-link" :class="{'is-active': isTextActive, 'has-error': hasError}" @click="switchToText">Text (fallback)</a>
                            </li>
                        </ul>
                    </div>
                    <merge-content @merge-content="mergeContent" :disabled="isTextActive" :event="event"/>
                    <add-placeholders :is-text-active="isTextActive" :placeholder-indexes="placeholderIndexes" @add-placeholder="addPlaceholder"/>
                </div>
            </div>
            <div class="editor-textarea-wrapper">
                <textarea
                    v-fs-block
                    ref="textarea"
                    class="editor-textarea"
                    rows="20"
                    @focusin="focused = true"
                    @focusout="focused = false"
                    v-model="content"></textarea>
            </div>
        </div>
    </div>
</template>

<script>
    import {EmailModel} from '@/common/models/rules/actions/send-email-action-model';
    import EventModel from '@/common/models/rules/event-model';
    import {vIcon, vIconButton} from '@/components/form';
    import MergeContent from './merge-content';
    import AddPlaceholders from './add-placeholders';

    export default {
        name: 'email-content',
        components: {
            vIcon, vIconButton, MergeContent, AddPlaceholders,
        },
        props: {
            email: {
                type: EmailModel,
            },
            event: {
                type: EventModel,
            },
            placeholderIndexes: Array,
            validate: Object,
        },
        computed: {
            content: {
                get() {
                    return this.isTextActive ? this.email.text : this.email.html;
                },
                set(content) {
                    const update = this.isTextActive ? 'text' : 'html';
                    const sibling = !this.isTextActive ? 'text' : 'html';
                    this.$emit('input', {
                        [update]: content,
                        [sibling]: this.email[sibling],
                    });
                },
            },
            hasError() {
                return !this.validate.content;
            },
        },
        data() {
            return {
                focused: false,
                isTextActive: false,
            };
        },
        methods: {
            switchToText() {
                this.isTextActive = true;
            },
            switchToHTML() {
                this.isTextActive = false;
            },
            /**
             * Use the provided string content and insert it into the textarea either at
             * the position of the cursor or by replacing an existing text selection within.
             * @param {string} content
             */
            addPlaceholder({content}) {
                const currentContent = this.content || '';
                const {selectionStart = 0, selectionEnd = 0} = this.$refs.textarea;
                const before = currentContent.substring(0, selectionStart);
                const after = currentContent.substring(selectionEnd);
                this.content = `${before}${content}${after}`;
                this.$nextTick(() => {
                    this.$refs.textarea.focus();
                    this.$refs.textarea
                        .setSelectionRange(selectionStart, selectionStart + content.length);
                });
            },
            /**
             * Replace the entire textarea content with pre-made content selected by the user.
             * @param {string} content
             */
            mergeContent({content}) {
                this.content = content;
                this.$nextTick(() => {
                    this.$refs.textarea.focus();
                    this.$refs.textarea
                        .setSelectionRange(0, content.length);
                });
            },
        },
    };
</script>
